export class GeoMap extends HTMLElement
{
    constructor ()
    {
        super();
        this.#init();
     }



    #init()
    {
    }

    initMap() {
        return new Promise(async (resolve, reject) => {
            try {
                const { AdvancedMarkerElement } = await google.maps.importLibrary("marker"); // as google.maps.MarkerLibrary;


                const {Map} = await google.maps.importLibrary("maps");
                this.map = new Map(document.getElementById(this.getMapID()), {
                    center: {lat: 32.8329792, lng: -117.1569285},
                    zoom: 11,
                    mapId: 'dc9ab0e69a63abfe',
                    streetViewControl: false,
                    scaleControl: true,
                    options: {
                        gestureHandling: 'greedy'
                    }
                });
                this.setCurrentPosition();
                resolve(this.map);
            } catch(error) {
                reject(error);
            }
        });
    }

    getMapID()
    {
        return 'geo-map';
    }

    setCurrentPosition()
    {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };

                    this.map.setCenter(pos);
                },
                () => {
                    this.handleLocationError(true, this.map.getCenter());
                }
            );
        } else {
            // Browser doesn't support Geolocation
            this.handleLocationError(false, this.map.getCenter());
        }

    }

    handleLocationError(browserHasGeolocation, pos)
    {
        console.log('handleLocationError, browserHasGeolocation: ' + browserHasGeolocation + ', pos: ' + pos);
    }


    initEventHandlers()
    {
        console.log('initevent');
    }


}